import endpoints from "../endpoints";

export default async function getBankAccountDetails(id) {
  let env = process.env.REACT_APP_ENV?.trim()
  // `${endpoints.BUSINESS_BANKING.GET_BANK_ACCOUNT_DETAILS[env]}/${id}` ==> use this for aws backend
  return await (await fetch(endpoints.BUSINESS_BANKING.GET_BANK_ACCOUNT_DETAILS[env])).json();
}
